(function () {
    'use strict';
    async function main() {
        var page = wo$('#media');
        if (!page.length) return;
        var controller = {
            init: async function () {
                var firstMediaItem = page.find('div[data-mediasummaries] div:first-child');
                if (firstMediaItem.data('media') !== undefined) {
                    firstMediaItem.removeClass('bor-t-1');
                }
                await WhistleOut.bindSlick();
                page.find('#load-more button')
                    .off('click')
                    .click(function () {
                        page.find('#load-more button .fa-spinner').show();
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        var element = page.find('[data-mediasummaries]');
                        var url = element.data('pagingurl');
                        var current = element.data('current');
                        var pageSize = element.data('pagesize');
                        wo$.ajax({
                            url: WhistleOut.updateQueryStringParameter(url, 'current', current),
                            type: 'GET',
                            success: function (result) {
                                var $result = wo$(result);
                                if ($result.filter(':first').data('load-more') === 'False') {
                                    page.find('#load-more').hide();
                                } else {
                                    page.find('#load-more').show();
                                }
                                element.append($result.html());
                                element.data('current', current + pageSize);
                                page.find('#load-more button .fa-spinner').hide();
                                wo$('[data-enable-when-ready]').removeAttr('disabled');
                            }
                        });
                    });

                wo$('.video-carousel').slick({
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    responsive: [
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                infinite: true,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                                dots: false
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: false
                            }
                        }
                    ]
                });
            }
        };

        await controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
